
define('css!ui/loadingButton/css/button',[],function(){});
